import Vue from 'vue';

export function setCompanyRules(state, { slug, rules }) {
   Vue.set(state.rules, slug, rules);
}

export function insertOrUpdateCompanyRule(state, { slug, rule }) {
   if (!state.rules[slug]) {
      Vue.set(state.rules, slug, [rule]);
      state.rules[slug] = [rule];
      return;
   }
   const rules = state.rules[slug];
   const index = rules.findIndex(r => r.id === rule.id);
   if (index >= 0) {
      rules.splice(index, 1, rule);
   } else {
      rules.push(rule);
   }
}

export function removeCompanyRule(state, { slug, rule }) {
   if (state.rules[slug]) {
      const rules = state.rules[slug];
      const index = rules.findIndex(r => r.id === rule.id);
      if (index >= 0) {
         rules.splice(index, 1);
      }
   }
}

export function fetchingStarted(state, slug) {
   state.fetching.push(slug);
}

export function fetchingFinished(state, slug) {
   const index = state.fetching.indexOf(slug);
   if (index !== -1) {
      state.fetching.splice(index, 1);
   }
}

export function updatingStarted(state, id) {
   state.updating.push(id);
}

export function updatingFinished(state, id) {
   const index = state.updating.indexOf(id);
   if (index !== -1) {
      state.updating.splice(index, 1);
   }
}

export function setDefinitions(state, definitions) {
   state.definitionsLoaded = true;
   state.definitions = definitions;
}
